import { isBefore, isSameDay } from 'date-fns'

import {
  DATE_DAY_FORMAT,
  DATE_MONTH_ABBR_FORMAT,
} from '../../../constants/date'
import { toUkTimezoneDate } from '../../../utils/date'
import { formatDate } from '../../Table'

export function getViewingDateTileLabels({ locale, start, timezone }) {
  return {
    dayLabel: formatDate({
      date: start,
      dateFormat: DATE_DAY_FORMAT,
      locale,
      timezone,
      useTodayFormat: false,
    }),
    monthLabel: formatDate({
      date: start,
      dateFormat: DATE_MONTH_ABBR_FORMAT,
      locale,
      timezone,
      useTodayFormat: false,
    }),
  }
}

export function getIsViewingDatePast({ start, timezone }) {
  const startDate = toUkTimezoneDate(start, timezone)
  const currentDate = toUkTimezoneDate(new Date(), timezone)

  return isBefore(startDate, currentDate) && !isSameDay(startDate, currentDate)
}
